<div class="dialog">
  <div class="dialog-top">
    <h2 class="dialog-title short-text"> {{local_data.title}} </h2>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button"
      mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#bbb" />
      <path opacity="0.8"
        d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
        fill="#0080FF" />
    </svg>
  </div>
  <mat-dialog-content class="dialog-flex">


    <!-- Other Form -->
    @if (local_data.metodology != 'agile') {
    <form [formGroup]="formGroup1">
      <div class="form-group">
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.task}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <mat-select [errorStateMatcher]="matcher" formControlName="actionCtrl" [disabled]="isEdit" placeholder="">
            <mat-option>
              <ngx-mat-select-search formControlName="actionFilterCtrl" placeholderLabel={{variables.search}}
                noEntriesFoundLabel={{variables.noActionFound}}></ngx-mat-select-search>
            </mat-option>
            @for (item of filteredActions; track item) {
            <mat-option title={{item.name}} [value]="item.name">
              {{item.name}}
            </mat-option>
            }
          </mat-select>
          @if (formGroup1.get('actionCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
        </mat-form-field>
        @if (formGroup1.value.actionCtrl == variables.other) {
        <div>
          <label class="mb-2 input-label mandatory"><span>*</span> {{variables.nameOfTask}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <input matInput formControlName="actionOtherCtrl" placeholder="{{variables.addActionName}}" value="">
            @if (formGroup1.get('actionOtherCtrl')?.hasError('required')) {
            <mat-error>{{variables.mandatoryField}}</mat-error>
            }
          </mat-form-field>
        </div>
        }
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.subTask}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <mat-select [errorStateMatcher]="matcher" formControlName="activityCtrl" placeholder="">
            <mat-option>
              <ngx-mat-select-search formControlName="activityFilterCtrl" placeholderLabel={{variables.search}}
                noEntriesFoundLabel={{variables.noActionFound}}></ngx-mat-select-search>
            </mat-option>
            @for (item of filteredSubTasks; track item) {
            <mat-option title={{item.name}} [value]="item.name">
              {{item.name}}
            </mat-option>
            }
          </mat-select>
          @if (formGroup1.get('activityCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
        </mat-form-field>
        @if (formGroup1.value.activityCtrl == variables.other) {
        <div>
          <label class="mb-2 input-label mandatory"><span>*</span> {{variables.nameOfSubTask}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <input matInput formControlName="activityOtherCtrl" placeholder="{{variables.addSubTaskName}}" value="">
            @if (formGroup1.get('activityOtherCtrl')?.hasError('required')) {
            <mat-error>{{variables.mandatoryField}}</mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (formGroup1.value.actionCtrl != variables.other && formGroup1.value.actionCtrl) {
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.complexity}}</label>
        }
        @if (formGroup1.value.actionCtrl == variables.other && formGroup1.value.actionCtrl) {
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.effortIn}} {{variables.hours}}</label>
        }
        @if (formGroup1.value.actionCtrl) {
        <mat-form-field class="form-field" appearance="outline">
          @if (formGroup1.value.actionCtrl != variables.other && !isEdit) {
          <mat-select formControlName="complexityCtrl">
            <mat-select-trigger>
              {{ formGroup1.value?.complexityCtrl === 1 ? (variables.low1 + ' - ' +
              complexities.complexityLow + ' ' + variables.hours) :
              formGroup1.value?.complexityCtrl === 2 ? (variables.medium1 + ' - ' +
              complexities.complexityMedium + ' ' + variables.hours) :
              formGroup1.value?.complexityCtrl === 3 ? (variables.high1 + ' - ' +
              complexities.complexityHigh + ' ' + variables.hours) :
              '' }}
            </mat-select-trigger>
            <mat-option [value]=1
              [matTooltip]="complexities.detailsLow ? getDescription(complexities.detailsLow) : ''"
              [matTooltipDisabled]="!complexities.detailsLow"
              [matTooltipPosition]="'right'"
              matTooltipClass="tool-tip">{{variables.low1}} - {{complexities.complexityLow}} {{variables.hours}}
            </mat-option>
            <mat-option [value]=2
              [matTooltip]="complexities.detailsMedium ? getDescription(complexities.detailsMedium) : ''"
              [matTooltipDisabled]="!complexities.detailsMedium"
              [matTooltipPosition]="'right'"
              matTooltipClass="tool-tip">{{variables.medium1}} - {{complexities.complexityMedium}} {{variables.hours}}
            </mat-option>
            <mat-option [value]=3
              [matTooltip]="complexities.detailsHigh ? getDescription(complexities.detailsHigh) : ''"
              [matTooltipDisabled]="!complexities.detailsHigh"
              [matTooltipPosition]="'right'"
              matTooltipClass="tool-tip">{{variables.high1}} - {{complexities.complexityHigh}} {{variables.hours}}
            </mat-option>
          </mat-select>
          }
          @if (formGroup1.value.actionCtrl != variables.other && isEdit) {
          <mat-select formControlName="complexityCtrl">
            @for (complex of editComplexities; track complex) {
            <mat-option [value]="complex.complex">{{complex.name}}</mat-option>
            }
          </mat-select>
          }
          @if (formGroup1.value.actionCtrl == variables.other) {
          <input matInput type="number" formControlName="effortOtherCtrl" placeholder="{{variables.addComplexity}}"
            value="">
          }
          @if (formGroup1.get('effortOtherCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
        </mat-form-field>
        }
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.itens}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput type="number" placeholder="1" formControlName="itemsCtrl" (input)="handleInput($event)">
          @if (formGroup1.get('itemsCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
          @if (formGroup1.get('itemsCtrl')?.hasError('invalidValue')) {
          <mat-error>{{variables.numberGreaterThenZero}}</mat-error>
          }
          @if (formGroup1.get('itemsCtrl')?.hasError('decimal')) {
          <mat-error>{{variables.numberInteger}}</mat-error>
          }
        </mat-form-field>
        <!-- Center / Profile selectors -->
        @if (profiles.length > 0) {
        <div>
          <label class="mb-2 input-label">{{variables.center}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="centerCtrl" (selectionChange)="onCenterChange($event.value)">
              <mat-option value="">--</mat-option>
              @for (c of centers; track c) {
              <mat-option [value]="c">{{c}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <label class="mb-2 input-label">{{variables.profile}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="profileCtrl">
              <mat-option value="">--</mat-option>
              @for (p of filteredProfiles; track p) {
              <mat-option [value]="p.id">{{p.name}} - {{p.costPerHour}} {{variables.eurosPerHour}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
    </form>
    }


    <!-- Agile Form -->
    @if (local_data.metodology == 'agile') {
    <form [formGroup]="formGroup2">
      <label class="mb-2 input-label mandatory"><span>*</span> {{variables.epic}} </label>
      <mat-form-field class="form-field" appearance="outline">
        <input matInput formControlName="epicCtrl" [matAutocomplete]="epicAuto" placeholder="{{variables.nameOfEpic}}">
        <mat-autocomplete #epicAuto="matAutocomplete">
          @for (epic of filteredEpics; track epic) {
          <mat-option [value]="epic">
            {{ epic }}
          </mat-option>
          }
        </mat-autocomplete>
        @if (formGroup2.get('epicCtrl')?.hasError('required')) {
        <mat-error>{{variables.mandatoryField}}</mat-error>
        }
      </mat-form-field>
      <label class="mb-2 input-label mandatory"><span>*</span> {{variables.userStory}} </label>
      <mat-form-field class="form-field" appearance="outline">
        <input matInput formControlName="userStoryCtrl" [matAutocomplete]="userStoryAuto"
          placeholder="{{variables.nameOfUserStory}}">
        <mat-autocomplete #userStoryAuto="matAutocomplete">
          @for (us of filteredUserStories; track us) {
          <mat-option [value]="us">
            {{ us }}
          </mat-option>
          }
        </mat-autocomplete>
        @if (formGroup2.get('userStoryCtrl')?.hasError('required')) {
        <mat-error>{{variables.mandatoryField}}</mat-error>
        }
      </mat-form-field>
      <label class="mb-2 input-label mandatory"><span>*</span> {{variables.task}} </label>
      <mat-form-field class="form-field" appearance="outline">
        <mat-select [errorStateMatcher]="matcher" formControlName="taskCtrl" [disabled]="isEdit" placeholder="">
          <mat-option>
            <ngx-mat-select-search formControlName="taskFilterCtrl" placeholderLabel={{variables.search}}
              noEntriesFoundLabel={{variables.noActionFound}}></ngx-mat-select-search>
          </mat-option>
          @for (item of filteredActions; track item) {
          <mat-option title={{item.name}} [value]="item.name">
            {{item.name}}
          </mat-option>
          }
        </mat-select>
        @if (formGroup2.get('taskCtrl')?.hasError('required')) {
        <mat-error>{{variables.mandatoryField}}</mat-error>
        }
      </mat-form-field>
      @if (formGroup2.value.taskCtrl == variables.other) {
      <div>
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.nameOfTask}} </label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="taskOtherCtrl" placeholder="{{variables.addActionName}}" value="">
          @if (formGroup2.get('taskOtherCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
        </mat-form-field>
      </div>
      }
      <label class="mb-2 input-label mandatory"><span>*</span> {{variables.subTask}} </label>
      <mat-form-field class="form-field" appearance="outline">
        <mat-select [errorStateMatcher]="matcher" formControlName="subTaskCtrl" placeholder="">
          <mat-option>
            <ngx-mat-select-search formControlName="subTaskFilterCtrl" placeholderLabel={{variables.search}}
              noEntriesFoundLabel={{variables.noActionFound}}></ngx-mat-select-search>
          </mat-option>
          @for (item of filteredSubTasks; track item) {
          <mat-option title={{item.name}} [value]="item.name">
            {{item.name}}
          </mat-option>
          }
        </mat-select>
        @if (formGroup2.get('subTaskCtrl')?.hasError('required')) {
        <mat-error>{{variables.mandatoryField}}</mat-error>
        }
      </mat-form-field>
      @if (formGroup2.value.subTaskCtrl == variables.other) {
      <div>
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.nameOfSubTask}} </label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="subTaskOtherCtrl" placeholder="{{variables.addSubTaskName}}" value="">
          @if (formGroup2.get('subTaskOtherCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (formGroup2.value.taskCtrl && local_data.estimateMode !=null) {
      <div>
        @if (formGroup2.value.taskCtrl != variables.other && formGroup2.value.taskCtrl && local_data.estimateMode ==
        'complex') {
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.complexity}} </label>
        }
        @if (formGroup2.value.taskCtrl == variables.other && formGroup2.value.taskCtrl && local_data.estimateMode ==
        'complex') {
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.effortIn}} {{variables.hours}} </label>
        }
        @if (formGroup2.value.taskCtrl && local_data.estimateMode == 'complex') {
        <mat-form-field class="form-field" appearance="outline">
          @if (formGroup2.value.taskCtrl != variables.other && !isEdit) {
          <mat-select formControlName="complexityCtrl">
            <mat-select-trigger >

              {{ formGroup2.value?.complexityCtrl === 1 ? (variables.low1 + ' - ' +
              complexities.complexityLow + ' ' + variables.hours) :
              formGroup2.value?.complexityCtrl === 2 ? (variables.medium1 + ' - ' +
              complexities.complexityMedium + ' ' + variables.hours) :
              formGroup2.value?.complexityCtrl === 3 ? (variables.high1 + ' - ' +
              complexities.complexityHigh + ' ' + variables.hours) :
              '' }}
            </mat-select-trigger>
            <mat-option [value]=1
              [matTooltip]="complexities.detailsLow ? getDescription(complexities.detailsLow) : ''"
              [matTooltipDisabled]="!complexities.detailsLow"
              [matTooltipPosition]="'right'"
              matTooltipClass="tool-tip">{{variables.low1}} - {{complexities.complexityLow}} {{variables.hours}}
            </mat-option>
            <mat-option [value]=2
              [matTooltip]="complexities.detailsMedium ? getDescription(complexities.detailsMedium) : ''"
              [matTooltipDisabled]="!complexities.detailsMedium"
              [matTooltipPosition]="'right'"
              matTooltipClass="tool-tip">{{variables.medium1}} - {{complexities.complexityMedium}} {{variables.hours}}
            </mat-option>
            <mat-option [value]=3
              [matTooltip]="complexities.detailsHigh ? getDescription(complexities.detailsHigh) : ''"
              [matTooltipDisabled]="!complexities.detailsHigh"
              [matTooltipPosition]="'right'"
              matTooltipClass="tool-tip">{{variables.high1}} - {{complexities.complexityHigh}} {{variables.hours}}
            </mat-option>
          </mat-select>
          }
          @if (formGroup2.value.taskCtrl != variables.other && isEdit) {
          <mat-select formControlName="complexityCtrl">
            @for (complex of editComplexities; track complex) {
            <mat-option [value]="complex.complex">{{complex.name}}</mat-option>
            }
          </mat-select>
          }
          @if (formGroup2.value.taskCtrl == variables.other) {
          <input matInput formControlName="complexityOtherCtrl" type="number" min="0.01" step="0.01"
            placeholder="0.01" value="">
          }
          @if (formGroup2.get('complexityOtherCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
          @if (formGroup2.get('complexityCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
        </mat-form-field>
        }
        @if (formGroup2.value.taskCtrl && local_data.estimateMode == 'tshirt' && formGroup2.value.taskCtrl !=
        variables.other) {
        <div>
          <label class="mb-2 input-label mandatory"><span>*</span> {{variables.effortPerTshirtScale}} </label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select [errorStateMatcher]="matcher" formControlName="tshirtScaleCtrl" placeholder="">
              <mat-option>
                <ngx-mat-select-search formControlName="tshirtScaleFilterCtrl" placeholderLabel={{variables.search}}
                  noEntriesFoundLabel={{variables.noActionFound}}></ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="'XS'">
                XS - {{complexities?.tshirtXS}} {{variables.days}}
              </mat-option>
              <mat-option [value]="'S'">
                S - {{complexities?.tshirtS}} {{variables.days}}
              </mat-option>
              <mat-option [value]="'M'">
                M - {{complexities?.tshirtM}} {{variables.days}}
              </mat-option>
              <mat-option [value]="'L'">
                L - {{complexities?.tshirtL}} {{variables.days}}
              </mat-option>
              <mat-option [value]="'XL'">
                XL - {{complexities?.tshirtXL}} {{variables.days}}
              </mat-option>
              <mat-option [value]="'XXL'">
                XXL - {{complexities?.tshirtXXL}} {{variables.days}}
              </mat-option>
            </mat-select>
            @if (formGroup2.get('tshirtScaleCtrl')?.hasError('required')) {
            <mat-error>{{variables.mandatoryField}}</mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (formGroup2.value.taskCtrl == variables.other && local_data.estimateMode == 'tshirt') {
        <div>
          <label class="mb-2 input-label mandatory"><span>*</span> {{variables.effortInDays}} </label>
          <mat-form-field class="form-field" appearance="outline">
            <input matInput type="number" min="1" formControlName="tshirtOtherScaleCtrl" placeholder="1" value="">
            @if (formGroup2.get('tshirtOtherScaleCtrl')?.hasError('required')) {
            <mat-error>{{variables.mandatoryField}}</mat-error>
            }
          </mat-form-field>
        </div>
        }
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables.itens}} </label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput type="number" placeholder="1" formControlName="itemsCtrl" (input)="handleInput($event)">
          @if (formGroup2.get('itemsCtrl')?.hasError('required')) {
          <mat-error>{{variables.mandatoryField}}</mat-error>
          }
          @if (formGroup2.get('itemsCtrl')?.hasError('invalidValue')) {
          <mat-error>{{variables.numberGreaterThenZero}}</mat-error>
          }
          @if (formGroup2.get('itemsCtrl')?.hasError('decimal')) {
          <mat-error>{{variables.numberInteger}}</mat-error>
          }
        </mat-form-field>
        <!-- Center / Profile selectors -->
        @if (profiles.length > 0) {
        <div>
          <label class="mb-2 input-label">{{variables.center}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="centerCtrl" (selectionChange)="onCenterChange($event.value)">
              <mat-option value="">--</mat-option>
              @for (c of centers; track c) {
              <mat-option [value]="c">{{c}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <label class="mb-2 input-label">{{variables.profile}}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="profileCtrl">
              <mat-option value="">--</mat-option>
              @for (p of filteredProfiles; track p) {
              <mat-option [value]="p.id">{{p.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
      }
    </form>
    }
    <div>
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" message="{{variables.cancel}}" mat-dialog-close></app-button>
        @if (local_data.metodology != 'agile') {
        <app-button typeBtn="primary" (click)="doAction()" [message]="isEdit ? variables.update : variables.add"
          style="margin-left: 10px;"></app-button>
        }
        @if (local_data.metodology == 'agile') {
        <app-button typeBtn="primary" (click)="submitAgileForm()" [message]="isEdit ? variables.update : variables.add"
          style="margin-left: 10px;"></app-button>
        }
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>
</div>